/**
 * CLIENT-SIDE fast-path skip, ported verbatim in behaviour from
 * cc-learning-app's src/Hooks/LoginApi/loginApi.helpers.ts.
 *
 * WHY: Application.tsx gates the whole app on
 *   isUserOnboarded(data) === data.data.user.learning_onboarding_status
 * which is a NUMBER. A brand-new user has status 0, which is falsy, so the
 * gate fails and the navigator renders `OnboardingScreenStack` (importgames /
 * selectavatar / onboardingprogress) as the ONLY routes — stranding fresh
 * users on /importgames straight after OTP.
 *
 * Patching a fresh-new user (status null/0) to look onboarded lets those gates
 * pass so they land on the dashboard, where the OnboardingChecklistSheet modal
 * drives profile completion instead of a full-screen wizard. This is the same
 * simplification cc-learning-app shipped.
 *
 * Status semantics that must NOT be touched:
 *   2 — games still being analysed (Dashboard shows its own banner for this)
 *   3 — special/connection state
 *   1 — already onboarded
 */
export const applyFastPathGates = (user: any): any => {
  if (!user) return user;
  const status = user.learning_onboarding_status;
  const isFreshNew = status == null || status === 0;
  if (!isFreshNew) return user;
  const seen = Array.isArray(user.seen_walkthroughs)
    ? user.seen_walkthroughs
    : [];
  return {
    ...user,
    learning_onboarding_status: 1,
    seen_walkthroughs: seen.includes('learning') ? seen : [...seen, 'learning'],
  };
};
